import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import AppStyle from "./App.module.css";
import { Image } from 'antd';
import {
  getTextLiteral,
  getTopDisclaimer,
  // getPageDisclaimer,
  getTopDisclaimerMap,
  getIFrameData
} from "./service/textRetrieval";

import VOCVOIProgressionChart from "components/VOCVOIProgressionChart/ProgressionChart";
import CityMap from "components/CityMap/CityMap";
import {getData} from "service/GenericData";
// import VOCVOIContinentsPieCharts from "components/VOCVOIContinentsPieCharts/PieCharts";
import ChinaSubmissionSummaryText from "components/ChinaSubmissionSummaryText/index"

function App() {
  const [textLiterals, setTextLiterals] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(true);
  const [charts, setCharts] = React.useState(["Vp"]);
  const [topDisclaimer, setTopDisclaimer] = React.useState("");
  const [topDisclaimerTmp, setTopDisclaimerTmp] = React.useState("");
  const [topDisclaimerMap, setTopDisclaimerMap] = React.useState("");
  const [topDisclaimerMapTmp, setTopDisclaimerMapTmp] = React.useState("");
  const [utctime, setUtctime] = React.useState();
  const [iFrameData, setIFrameData] = React.useState({});
  const [mapData, setMapData] = React.useState([])
  const [chinaSubmissionData, setChinaSubmissionData]=React.useState([])
  const [latestChinaSubmissionDate, setLatestChinaSubmissionDate]=React.useState([])
  // const [urlParams,setUrlParams] = React.useState([]);

  // method 2: test url: http://localhost:3000/?sessionid=1
  React.useEffect(() => {
    getTextLiteral().then((textLiterals) => {
      setTextLiterals(textLiterals);
      setTopDisclaimerTmp(getTopDisclaimer(textLiterals));
      setTopDisclaimerMapTmp(getTopDisclaimerMap(textLiterals))
      setIFrameData(getIFrameData(textLiterals));
      setIsLoading(false);
    });
    getData("utctime").then((result)=>{
      // 11 January 2023 13:05UTC
      // convert date time format
      var utcTimestamp=result.utcTimestamp
      utcTimestamp=utcTimestamp.replace('UTC',' UTC')
      var utcDate=new Date(utcTimestamp)
      var datestring = utcDate.getFullYear()+"-"+("0"+(utcDate.getMonth()+1)).slice(-2) +"-" +( "0" + utcDate.getDate()).slice(-2) + " " + ("0" + utcDate.getHours()).slice(-2) + ":" + ("0" + utcDate.getMinutes()).slice(-2);
      setUtctime(datestring);
    });
    getData('china_submission').then((result) => {
      if (result) {
        setChinaSubmissionData(result)
        setLatestChinaSubmissionDate(result.latestSubmissionDate)
      } 
    });
    // getData('latestSubmissionDate').then((result) => {
    //   if (result) {
    //     setLatestChinaSubmissionDate(result.latestSubmissionDate)
    //   } 
    // });
    getData('hcov19_lineage_map').then((result) => {
      if (result) {
        setMapData(result)
      } 
      setIsLoading(false);
    });
  }, []);

  React.useEffect(() => {
    setTopDisclaimer(topDisclaimerTmp.replace("<utcTimestamp>", utctime));
    setTopDisclaimerMap(topDisclaimerMapTmp.replace("<utcTimestamp>", utctime));
    // setIsLoading(false);
  },[topDisclaimerTmp,topDisclaimerMapTmp,utctime]);

  return isLoading ? null : (
    <Container className={AppStyle.container}>
      <Row className="justify-content-md-center" >
        <Col xs={1} lg={1} className="mb-1">
        <hr/>
        </Col>
      </Row>
      <Row className="mb-3 justify-content-center">
        <div className={AppStyle.topDisclaimer}>
            {topDisclaimer}
        </div>
      </Row>
      <Row  >
        {charts.includes('Vp') &&
          <Col xs={12} lg={12} className="mb-1">
            <VOCVOIProgressionChart textLiterals={textLiterals}  />
          </Col>
        }
      </Row>
      <Row className="mt-3 justify-content-md-center">
        <Col xs={12} lg={10} className="mb-2">
          <ChinaSubmissionSummaryText data={chinaSubmissionData} latestChinaSubmissionDate={latestChinaSubmissionDate}/>
        </Col>
      </Row>
      <Row className="justify-content-md-center" >
        <Col xs={1} lg={1} className="mb-1">
        <hr/>
        </Col>
      </Row>
      <Row>
        <Col lg={12} xl={6}>
          <Row className="mb-3 justify-content-center" >
            <Col lg={11}>
            <div className={AppStyle.topDisclaimer}>
                {topDisclaimerMap}
            </div>
            </Col>
          </Row>
          <Row className="mt-3" >
            <Col xs={12} lg={12} className="mb-2">
              <CityMap textLiterals={textLiterals} data={mapData} />
            </Col>
          </Row>
        </Col>
        <Col lg={12} xl={6} className="mt-4 justify-content-center">
          <Row className=" justify-content-center">
            <h3 className={AppStyle.treeTitle}>{textLiterals.treeTitle}</h3>
          </Row>
          <Row className="justify-content-center">
            <Image
              className={AppStyle.treeImage}
              // width={200}
              // height={'auto'}
              // width={'auto'}
              // maxWidth={700}
              src="tree.jpeg"
            />
          </Row>
        </Col>
      </Row>
      
      <Row className="justify-content-md-center" >
        <Col xs={1} lg={1} className="mb-2">
        <hr/>
        </Col>
      </Row>
      <Row className="mb-4">
          <iframe
            title="Tree"
            src={iFrameData}
            style={{
              border: "none",
              width: "100%",
              height: "600px",
            }}
            className="mb-3"
          />
        </Row>
    </Container>
  );
}

export default App;
